import { withInstall } from '@/utils/install'
import comp from './FileFieldComp.vue'

const FileField = withInstall(comp)

export default FileField
